/* © CNES */
import './ProcessHeader.scss';

/**
 * Process Header in Dialog.
 * @returns Element.
 */
export const ProcessHeader = () => {
  return (
    <>
      <div className="ProcessTitle">
        <div className="ProcessIcon"></div>
        <h2 className="PageTitle">Process</h2>
      </div>
    </>
  );
};
